import { FaCreditCard } from "react-icons/fa";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "royalOne",
  title: "Royal ONE",
  type: "document",
  icon: FaCreditCard,
  fieldsets: [
    {
      name: "offer",
      title: "Offer section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "organicPageHero",
      title: "Hero section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "manageCard",
      title: "Manage Card section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "pointsEarning",
      title: "Points earning section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "cardHolderBenefitsSection",
      title: "Card holder Benefits section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "cardComparison",
      title: "Card comparison section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "plusOffer",
      title: "Offer section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "plusPointsEarning",
      title: "Points earning section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "plusCardHolderBenefitsSection",
      title: "Card holder Benefits section",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "plusCardComparison",
      title: "Card comparison section",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  groups: [
    {
      name: "royalOneCard",
      title: "Royal ONE Card"
    },
    {
      name: "royalOnePlusCard",
      title: "Royal ONE Plus Card"
    },
    {
      name: "organicPage",
      title: "Organic Page"
    },
    { name: "asCard", title: "Render as Card" },
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    defineField({
      name: "royalOneCardName",
      title: "Royal ONE Card name",
      type: "string",
      group: "royalOneCard",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "royalOneCardImage",
      title: "Royal ONE Card image",
      type: "imageWithAlt",
      options: { hotspot: true },
      group: "royalOneCard",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "offerSubtitle",
      title: "Offer subtitle",
      type: "multilingualArrayString",
      group: "royalOneCard",
      fieldset: "offer",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "offerDescription",
      title: "Offer description",
      type: "multilingualArrayBlockContent",
      group: "royalOneCard",
      fieldset: "offer",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "offerAnnualFee",
      title: "Offer Annual fee",
      type: "multilingualArrayString",
      group: "royalOneCard",
      fieldset: "offer"
    }),
    defineField({
      name: "pointsEarningTitle",
      title: "Points earning title",
      type: "multilingualArrayString",
      group: "royalOneCard",
      fieldset: "pointsEarning",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "pointsEarningContent",
      title: "Points earning content",
      type: "serviceRow",
      options: { collapsible: true },
      group: "royalOneCard",
      fieldset: "pointsEarning",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "cardHolderBenefitsTitle",
      title: "Card holder Benefits title",
      type: "multilingualArrayString",
      group: "royalOneCard",
      fieldset: "cardHolderBenefitsSection",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "cardHolderBenefitsContent",
      title: "Card holder Benefits content",
      type: "milestones",
      group: "royalOneCard",
      fieldset: "cardHolderBenefitsSection",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "compareCta",
      title: "Card comparison CTA",
      type: "ctaButtons",
      options: { collapsible: true },
      group: "royalOneCard",
      fieldset: "cardComparison",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "compareItems",
      title: "Card comparison items",
      type: "array",
      of: [{ type: "cardComparisonItem" }],
      group: "royalOneCard",
      fieldset: "cardComparison",
      validation: (Rule) => Rule.required().min(1)
    }),
    defineField({
      name: "royalOnePlusCardName",
      title: "Royal ONE Plus Card name",
      type: "string",
      group: "royalOnePlusCard",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "royalOnePlusCardImage",
      title: "Royal ONE Plus Card image",
      type: "imageWithAlt",
      options: { hotspot: true },
      group: "royalOnePlusCard",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusOfferSubtitle",
      title: "Offer subtitle",
      type: "multilingualArrayString",
      group: "royalOnePlusCard",
      fieldset: "plusOffer",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusOfferDescription",
      title: "Offer description",
      type: "multilingualArrayBlockContent",
      group: "royalOnePlusCard",
      fieldset: "plusOffer",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusOfferAnnualFee",
      title: "Offer Annual fee",
      type: "multilingualArrayString",
      group: "royalOnePlusCard",
      fieldset: "plusOffer"
    }),
    defineField({
      name: "plusPointsEarningTitle",
      title: "Points earning title",
      type: "multilingualArrayString",
      group: "royalOnePlusCard",
      fieldset: "plusPointsEarning",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusPointsEarningContent",
      title: "Points earning content",
      type: "serviceRow",
      options: { collapsible: true },
      group: "royalOnePlusCard",
      fieldset: "plusPointsEarning",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusCardHolderBenefitsTitle",
      title: "Card holder Benefits title",
      type: "multilingualArrayString",
      group: "royalOnePlusCard",
      fieldset: "plusCardHolderBenefitsSection",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusCardHolderBenefitsContent",
      title: "Card holder Benefits content",
      type: "milestones",
      group: "royalOnePlusCard",
      fieldset: "plusCardHolderBenefitsSection",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusCompareCta",
      title: "Card comparison CTA",
      type: "ctaButtons",
      options: { collapsible: true },
      group: "royalOnePlusCard",
      fieldset: "plusCardComparison",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "plusCompareItems",
      title: "Card comparison items",
      type: "array",
      of: [{ type: "cardComparisonItem" }],
      group: "royalOnePlusCard",
      fieldset: "plusCardComparison",
      validation: (Rule) => Rule.required().min(1)
    }),
    defineField({
      name: "organicPageCardComparisonSectionTitle",
      title: "Organic Page - Card comparison section title",
      type: "sectionTitle",
      group: "organicPage"
    }),
    defineField({
      name: "alreadyCardholderLabel",
      title: "Already Cardholder label",
      type: "multilingualArrayString",
      group: "organicPage",
      fieldset: "manageCard",
      options: { collapsible: true, collapsed: true }
    }),
    defineField({
      name: "manageCardButton",
      title: "Manage Card button",
      type: "ctaButtons",
      fieldset: "manageCard",
      group: "organicPage",
      options: { collapsible: true, collapsed: true }
    }),
    defineField({
      name: "organicPageHeroImage",
      title: "Organic Page - Hero image",
      type: "imageWithAlt",
      options: { hotspot: true },
      group: "organicPage",
      fieldset: "organicPageHero",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "organicPageHeroTitle",
      title: "Organic Page - Hero title",
      type: "multilingualArrayString",
      group: "organicPage",
      fieldset: "organicPageHero"
    }),
    defineField({
      name: "organicPageHeroContent",
      title: "Organic Page - Hero content",
      type: "multilingualArrayText",
      group: "organicPage",
      fieldset: "organicPageHero"
    }),
    defineField({
      name: "organicPageHeroCta",
      title: "Organic Page - Hero CTA",
      type: "ctaButtons",
      options: { collapsible: true },
      group: "organicPage",
      fieldset: "organicPageHero"
    }),
    defineField({
      name: "organicPagePointsImage",
      title: "Organic Page - Royal Points image",
      type: "imageWithAlt",
      options: { hotspot: true },
      group: "organicPage",
      validation: (Rule) => Rule.required()
    }),
    {
      name: "card",
      title: "Render as Card",
      type: "asCard",
      group: "asCard"
    },
    {
      name: "metadata",
      title: "SEO, Routing & Tracking",
      type: "metadata",
      group: "seo"
    }
  ],
  preview: {
    prepare(value) {
      return {
        title: "Royal ONE"
      };
    }
  }
});
